import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setSelectedToken, toggleDestructionTool} from '../../redux/actions';
import styles from './Toolbar.styles';
import {selectDestructionToolActive, selectSelectedToken} from "../../redux/reducers/privateStateReducer/selectors";
import UnitIcon from "./NewUnitToolbar/UnitIcon/UnitIcon";
import {getUnitIconClassNameForButton} from "../../utils/unit/getUnitIconClassNameForButton";
import {NEUTRAL_PLAYER_COLOR} from "../../constants/players";
import {HexButtonFrame} from '../gameUi/HexButton';
import {joinClassNames} from '../gameUi/joinClassNames';
import {getPlayerColorStyle} from '../../utils/gameUi/getPlayerColorStyle';

const NeutralUnitsToolbar = ({tokens}) => {
  const dispatch = useDispatch();
  const selectedToken = useSelector(selectSelectedToken);
  const destructionToolActive = useSelector(selectDestructionToolActive);

  const handleTokenSelect = (tokenId) => {
    // Если инструмент разрушения активен, выключаем его при выборе токена
    if (destructionToolActive) {
      dispatch(toggleDestructionTool());
    }
    dispatch(setSelectedToken(tokenId));
  };

  return (
    <div style={styles.container}>
      <div style={styles.tokensGrid}>
        {tokens.map(token => (
          <button
            key={token.id}
            className={joinClassNames('gui-hex-button', 'gui-hex-button_stone', 'toolbar-button', selectedToken === token.id && 'gui-hex-button_selected')}
            style={getPlayerColorStyle(NEUTRAL_PLAYER_COLOR)}
            aria-pressed={selectedToken === token.id}
            onClick={() => handleTokenSelect(token.id)}
            title={token.label}
          >
            <div style={styles.tokenContent}>
              <UnitIcon
                unitType={token.id}
                playerColor={NEUTRAL_PLAYER_COLOR}
                className={getUnitIconClassNameForButton(token.id)}
              />
            </div>
            {/* Рамка — сосед обертки иконки: обводка силуэта (filter на обертке,
                ToolbarButton.css) не должна ее захватывать */}
            {selectedToken === token.id ? <HexButtonFrame className={'cell-icon'}/> : null}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NeutralUnitsToolbar;